import React from 'react';

import { useAppContext } from '@providers/AppContextProvider';

const RetryPaymentLoader: React.FC = () => {
  const { shopBundle } = useAppContext();

  const isSafari =
    window.navigator.userAgent.toLowerCase().includes('safari') &&
    window.navigator.vendor.toLowerCase().includes('apple computer');

  const zooplusLoader = isSafari ? (
    <div>
      <svg
        data-zta="retryPaymentSafariZooplusLoader"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 13.229166 13.229167"
        height={50}
        width={50}>
        <g transform="translate(0,-283.77082)">
          <ellipse
            ry="3.7561383"
            rx="3.2600446"
            cy="287.6687"
            cx="3.5199032"
            style={{ fill: '#808080', fillOpacity: 0, strokeWidth: '0.26458332' }}
          />
          <path
            d="M 12.224421,290.17957 A 5.6095939,5.8157001 0 0 1 7.8607878,295.85 5.6095939,5.8157001 0 0 1 1.55872,292.69851 a 5.6095939,5.8157001 0 0 1 1.5640962,-7.0704"
            style={{
              fill: '#808080',
              fillOpacity: 0,
              stroke: '#fffcff',
              strokeWidth: '2.12291667',
              strokeLinecap: 'round',
              strokeMiterlimit: 4,
              strokeDasharray: 'none',
              strokeOpacity: 1,
            }}
          />
        </g>
      </svg>
    </div>
  ) : (
    <svg
      data-zta="retryPaymentZooplusLoader"
      style={{ display: 'block' }}
      className="v3-come-in v3-btn__loader"
      width="44"
      height="44"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 -2 55 75"
      xmlSpace="preserve"
      preserveAspectRatio="xMidYMid">
      <g transform="rotate(45, 15, 35)" fill="#fff">
        <path d="M39.041,36.843c2.054,3.234,3.022,4.951,3.022,6.742c0,3.537-2.627,5.252-6.166,5.252c-1.56,0-2.567-0.002-5.112-1.326c0,0-1.649-1.509-5.508-1.354c-3.895-0.154-5.545,1.373-5.545,1.373c-2.545,1.323-3.516,1.309-5.074,1.309c-3.539,0-6.168-1.713-6.168-5.252c0-1.791,0.971-3.506,3.024-6.742c0,0,3.881-6.445,7.244-9.477c2.43-2.188,5.973-2.18,5.973-2.18h1.093v-0.001c0,0,3.698-0.009,5.976,2.181C35.059,30.51,39.041,36.844,39.041,36.843z" />
        <path
          className="v3-fade-in"
          d="M10.211,30.988c2.727-1.259,3.349-5.723,1.388-9.971s-5.761-6.672-8.488-5.414s-3.348,5.723-1.388,9.971C3.684,29.822,7.484,32.245,10.211,30.988z"
        />
        <path
          className="v3-fade-in v3-fade-in--two"
          d="M16.631,20.878c3.7,0,6.699-4.674,6.699-10.439S20.331,0,16.631,0S9.932,4.674,9.932,10.439S12.931,20.878,16.631,20.878z"
        />
        <path
          className="v3-fade-in v3-fade-in--three"
          d="M32.206,20.878c3.7,0,6.7-4.674,6.7-10.439S35.906,0,32.206,0s-6.699,4.674-6.699,10.439C25.507,16.204,28.506,20.878,32.206,20.878z"
        />
        <path
          className="v3-fade-in v3-fade-in--four"
          d="M45.727,15.602c-2.728-1.259-6.527,1.165-8.488,5.414s-1.339,8.713,1.389,9.972c2.728,1.258,6.527-1.166,8.488-5.414S48.455,16.861,45.727,15.602z"
        />
      </g>
    </svg>
  );

  return (
    <>
      {shopBundle === 'zooplus' && zooplusLoader}

      {shopBundle === 'bitiba' && (
        <svg
          data-zta="retryPaymentBitibaLoader"
          className={'v3-btn__loader'}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 13.229166 13.229167"
          height="50"
          width="50">
          <g transform="translate(0,-283.77082)">
            <ellipse
              ry="3.7561383"
              rx="3.2600446"
              cy="287.6687"
              cx="3.5199032"
              style={{ fill: '#808080', fillOpacity: 0, strokeWidth: '0.26458332' }}
            />
            <path
              d="M 12.224421,290.17957 A 5.6095939,5.8157001 0 0 1 7.8607878,295.85 5.6095939,5.8157001 0 0 1 1.55872,292.69851 a 5.6095939,5.8157001 0 0 1 1.5640962,-7.0704"
              style={{
                fill: '#808080',
                fillOpacity: 0,
                stroke: '#fffcff',
                strokeWidth: '2.12291667',
                strokeLinecap: 'round',
                strokeMiterlimit: 4,
                strokeDasharray: 'none',
                strokeOpacity: 1,
              }}
            />
          </g>
        </svg>
      )}
    </>
  );
};

export default RetryPaymentLoader;
